(() => {
  if (customElements.get('cf-case-carousel')) return;
  customElements.define('cf-case-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.spreads = [...this.querySelectorAll('[data-carousel-spread]')];
      if (!this.spreads.length) { this.hidden = true; return; }
      this.viewer = this.querySelector('[data-carousel-viewer]');
      this.dialog = this.querySelector('dialog');
      this.previous = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      this.position = this.querySelector('[data-carousel-position]');
      this.enlarge = this.querySelector('[data-carousel-enlarge]');
      this.total = this.querySelectorAll('.cf-carousel-page').length;
      this.step = Number(this.dataset.carouselStep) || 2;
      this.previous.addEventListener('click', () => this.show(this.index - 1));
      this.next.addEventListener('click', () => this.show(this.index + 1));
      this.viewer.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.viewer.addEventListener('pointerdown', event => {
        if (!event.target.closest('button')) this.startX = event.clientX;
      });
      this.viewer.addEventListener('pointercancel', () => { this.startX = undefined; });
      this.viewer.addEventListener('pointerup', event => {
        if (this.startX === undefined) return;
        const delta = event.clientX - this.startX;
        this.startX = undefined;
        if (Math.abs(delta) > 50) {
          this.swiped = true;
          this.show(this.index + (delta < 0 ? 1 : -1));
        }
      });
      this.viewer.addEventListener('click', event => {
        if (this.swiped) { event.preventDefault(); this.swiped = false; }
      });
      this.enlarge.addEventListener('click', () => {
        if (this.dialog.open) { this.dialog.close(); return; }
        this.querySelector('[data-carousel-expanded]').append(this.viewer);
        this.enlarge.textContent = 'Reduce ↙';
        this.dialog.showModal();
        this.viewer.querySelectorAll('img').forEach(img => {
          img.dataset.carouselOriginalSizes = img.sizes;
          img.sizes = '96vw';
        });
      });
      this.querySelector('[data-carousel-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => {
        this.querySelector('[data-carousel-home]').append(this.viewer);
        this.enlarge.textContent = 'Enlarge ↗';
        this.viewer.querySelectorAll('img').forEach(img => {
          if (img.dataset.carouselOriginalSizes) img.sizes = img.dataset.carouselOriginalSizes;
        });
        this.enlarge.focus();
      });
      this.show(0, false);
    }
    show(index, animate = true) {
      this.index = Math.max(0, Math.min(this.spreads.length - 1, index));
      this.spreads.forEach((spread, i) => { spread.hidden = i !== this.index; });
      const active = this.spreads[this.index];
      active.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      this.spreads[this.index + 1]?.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.spreads.length - 1;
      const first = this.index * this.step + 1;
      this.position.textContent = (this.step === 1 ? 'Image ' : 'Pages ') + first + (this.step > 1 && first < this.total ? '–' + Math.min(first + this.step - 1, this.total) : '') + ' of ' + this.total;
      if (animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) active.animate([{opacity:.65,transform:'rotateY(-5deg)'},{opacity:1,transform:'rotateY(0deg)'}],{duration:260,easing:'ease-out'});
    }
  });
})();
